import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({ providedIn: 'root' })
export class ClubService {

    private subject = new BehaviorSubject<string>('Initial Value')
    current = this.subject.asObservable()

    private arrayData = new BehaviorSubject([])
    currentArray = this.arrayData.asObservable()

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    // Upload banner
    getbannerimage() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/banner/list`).pipe(map(user => user));
    }

    uploadBannerImage(image: any) {
        const formData: FormData = new FormData();
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/banner/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateBannerImage(id: any, image: any) {
        const formData: FormData = new FormData();
        if (image) {
            formData.append('image', image, image.name);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/banner/update/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    deleteBannerImage(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/club/banner/delete/` + id).pipe(map(user => {
            return user;
        }));
    }

  getClubData(): Observable<any> {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/club/club-view`);
  }

 updateVideo(file: File): Observable<any> {
  const formData = new FormData();
  formData.append('video', file);   

  return this.http.put(
    `${environment.apiUrl}${environment.apiPrefix}/club/update-video`,
    formData
  );
}



updateFoodMenu(file: File): Observable<any> {
  const formData = new FormData();
  formData.append('foodMenu', file);

  return this.http.put(
    `${environment.apiUrl}${environment.apiPrefix}/club/update-foodMenu`,
    formData
  );
}

updateDrinkMenu(file: File): Observable<any> {
  const formData = new FormData();
  formData.append('drinkMenu', file);

  return this.http.put(
    `${environment.apiUrl}${environment.apiPrefix}/club/update-drinkMenu`,
    formData
  );
}

updateImageGallery(data: any ): Observable<any> {
  const formData = new FormData();
 // formData.append('images', data); 

  return this.http.put(
    `${environment.apiUrl}${environment.apiPrefix}/club/update-imageGallary`,
    data
  );
}


    clubstatusChange(status: any) {
        let formData =
        {
            'status': status
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/statusUpdate`, formData).pipe(map(user => {
            return user;
        }));
    }

    getClubStatus() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/status-view`).pipe(map(user => user));
    }

    //pricing
    addPrice(payload: any) {
        return this.http.post(`${environment.apiUrl}${environment.apiPrefix}/club/price/add`, payload);
    }

    getPriceList(page: number) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/price/list?page=${page}`);
    }

    getPriceSources(fromDate: string = '', toDate: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/price/sources?fromDate=${fromDate}&toDate=${toDate}`);
    }

    updatePrice(id: string, payload: any) {
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/club/price/update/${id}`, payload);
    }

    deletePrice(id: string) {
        return this.http.delete(`${environment.apiUrl}${environment.apiPrefix}/club/price/delete/${id}`);
    }

    //slot-generation
    generateSlot(payload: any) {
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/club/slots/create`,
                payload
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getSlotsByDate(date: string): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}${environment.apiPrefix}/club/slots/getByScheduleDate?date=${date}`
        );
    }

    getSlotDateRangeList(page: number, limit: number): Observable<any> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/club/slots/dateRangeList?page=${page}&limit=${limit}`);
    }

    updateSlotStatus(id: string, payload: { status: number }): Observable<any> {
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/club/slots/updateDateRange/${id}`, payload);
    }

    deleteSlotDateRange(id: string): Observable<any> {
        return this.http.delete(`${environment.apiUrl}${environment.apiPrefix}/club/slots/deleteDateRange/${id}`);
    }

    updateDailyPrices(payload: any) {
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/club/slots/updateDailyPrices`,
                payload
            )
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    updateDailySlotStatus(payload: any) {
        return this.http.post<any>(
            `${environment.apiUrl}${environment.apiPrefix}/club/slots/updateSlotStatus`,
            payload
        );
    }


updatePricesByDateRange(payload: any): Observable<any> {
  return this.http.post(`${environment.apiUrl}${environment.apiPrefix}/club/slots/updateByDateRange`, payload);
}

// Get bookings for date range
getClubBookings(fromDate: string, toDate: string): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/banner/list`).pipe(map(user => user));
}

// Get bookings for specific slot
getSlotBookings(slotId: string): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/banner/list`).pipe(map(user => user));
}

getBookingList( page: number ,status: number , search: string, fromDate?: string, toDate?: string): Observable<any> {
  const params: any = {
    page: page.toString(),
    orderStatus: status.toString()
  };

  if (search && search.trim()) {
    params.search = search.trim();
  }

  // Only sent when a range is actually chosen, so the unfiltered list is
  // unchanged for any other caller of this method.
  if (fromDate && toDate) {
    params.fromDate = fromDate;
    params.toDate = toDate;
  }

  return this.http.get<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/club/booking/list`,
    { params }
  ).pipe(map(res => res));
}


getBookingCount(): Observable<any> {
  return this.http.get<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/club/booking/count`
  ).pipe(map(res => res));
}

updateBookingStatus(
  bookingId: string,
  orderStatus: number,
  rejectedReason: string = ''
): Observable<any> {

  const payload: any = { orderStatus };

  if (rejectedReason && rejectedReason.trim()) {
    payload.rejectedReason = rejectedReason.trim();
  }

  return this.http.put<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/club/booking/update-status/${bookingId}`,
    payload
  ).pipe(map(res => res));
}


 getBookingById(bookingId: string): Observable<any> {
  return this.http.get<any>(
    `${environment.apiUrl}${environment.apiPrefix}/admin/club/booking/viewById/${bookingId}`
  ).pipe(map(res => res));
}

getBookings(fromDate: string, toDate: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/calender/daylist?fromDate=${fromDate}&toDate=${toDate}`
    ).pipe(map(response => response));
  }

  getSlots(dayId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/calender/slotlist/${dayId}`
    ).pipe(map(response => response));
  }

  getBookingListById(slotId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/calender/bookinglist/${slotId}`
    ).pipe(map(response => response));
  }

  // =================== DASHBOARD ===================

  getClubDashboardStats(fromDate?: string, toDate?: string): Observable<any> {
    const params: any = {};
    if (fromDate) { params.fromDate = fromDate; }
    if (toDate) { params.toDate = toDate; }

    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/dashboard/stats`,
      { params }
    ).pipe(map(res => res));
  }

  getClubDashboardRevenueOverview(fromDate?: string, toDate?: string): Observable<any> {
    const params: any = {};
    if (fromDate) { params.fromDate = fromDate; }
    if (toDate) { params.toDate = toDate; }

    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/dashboard/revenue-overview`,
      { params }
    ).pipe(map(res => res));
  }

  getClubDashboardRecentBookings(filters: {
    bookingType?: string;
    category?: string;
    search?: string;
    fromDate?: string;
    toDate?: string;
    orderStatus?: string;
    page?: number;
  }): Observable<any> {
    const params: any = {};
    if (filters.bookingType) { params.bookingType = filters.bookingType; }
    if (filters.category) { params.category = filters.category; }
    if (filters.search && filters.search.trim()) { params.search = filters.search.trim(); }
    if (filters.fromDate) { params.fromDate = filters.fromDate; }
    if (filters.toDate) { params.toDate = filters.toDate; }
    if (filters.orderStatus) { params.orderStatus = filters.orderStatus; }
    if (filters.page) { params.page = filters.page.toString(); }

    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/dashboard/recent-bookings`,
      { params }
    ).pipe(map(res => res));
  }

  getClubDashboardCategories(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}${environment.apiPrefix}/club/dashboard/categories`
    ).pipe(map(res => res));
  }

//   getExpandedBookingDetails(bookingId: string): Observable<any> {
//     return this.getBookingById(bookingId);
//   }


//   confirmBooking(bookingId: string): Observable<any> {
//     return this.updateBookingStatus(bookingId, 1);
//   }


//   rejectBooking(bookingId: string, reason: string): Observable<any> {
//     return this.updateBookingStatus(bookingId, 2, reason);
//   }

//   cancelBooking(bookingId: string): Observable<any> {
//     return this.updateBookingStatus(bookingId, 3);
//   }

    addDrinkPackage(payload: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/drinks-package/add`, payload);
    }

    getDrinkPackageList(page: number) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/drinks-package/list?page=${page}`);
    }

    updateDrinkPackage(id: string, payload: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/drinks-package/update/${id}`, payload);
    }

    deleteDrinkPackage(id: string) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/club/drinks-package/delete/${id}`);
    }

    addTableType(payload: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/table-type/add`, payload);
    }

    getTableTypeList(page: number) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/table-type/list?page=${page}`);
    }

    getTableTypeById(id: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/table-type/view/${id}`);
    }

    updateTableType(id: string, payload: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/table-type/update/${id}`, payload);
    }

    deleteTableType(id: string) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/club/table-type/delete/${id}`);
    }

    // Staff
    getStaffList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/list?page=${page}&search=${search}&status=${status}`).pipe(map(u => u));
    }

    createStaff(formData: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/add`, formData).pipe(map(u => u));
    }

    updateStaff(id: any, formData: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/update/${id}`, formData).pipe(map(u => u));
    }

    deleteStaff(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/delete/${id}`).pipe(map(u => u));
    }

    viewStaffById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/viewById/${id}`).pipe(map(u => u));
    }

    updateStaffPassword(id: any, password: string, confirm_password: string) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/update-password/${id}`, { password, confirm_password }).pipe(map(u => u));
    }

    getStaffDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/staff/dropdown`).pipe(map(u => u));
    }

    // Coupon
    createClubCoupon(formData: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/create`, formData).pipe(map(user => user));
    }

    getClubCouponList(page: any, search: any, status: any, from: string = '', to: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/list?page=${page}&search=${search}&status=${status}&from=${from}&to=${to}`).pipe(map(user => user));
    }

    getClubCouponById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/getById/${id}`).pipe(map(user => user));
    }

    updateClubCoupon(id: any, formData: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/update/${id}`, formData).pipe(map(user => user));
    }

    deleteClubCoupon(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/delete/${id}`).pipe(map(user => user));
    }

    updateClubCouponStatus(id: any, status: any) {
        const formData: FormData = new FormData();
        formData.append('status', status);
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/update/${id}`, formData).pipe(map(user => user));
    }

    getCouponApartmentDropdown(search: any = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/apartments-dropdown?search=${search}`).pipe(map(user => user));
    }

    getClubTargetDropdown(target: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/coupon/club-targets-dropdown?target=${target}`).pipe(map(user => user));
    }

    // Special Offers
    createClubSpecialOffer(formData: FormData) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/create`, formData).pipe(map(user => user));
    }

    getClubSpecialOfferList(page: any, search: any = '', status: any = '', from: string = '', to: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/list?page=${page}&search=${search}&status=${status}&from=${from}&to=${to}`).pipe(map(user => user));
    }

    getClubSpecialOfferStats() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/stats`).pipe(map(user => user));
    }

    getClubSpecialOfferById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/getById/${id}`).pipe(map(user => user));
    }

    updateClubSpecialOffer(id: any, formData: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/update/${id}`, formData).pipe(map(user => user));
    }

    deleteClubSpecialOffer(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/delete/${id}`).pipe(map(user => user));
    }

    updateClubSpecialOfferStatus(id: any, status: any) {
        const formData: FormData = new FormData();
        formData.append('status', status);
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/club/special-offer/update-status/${id}`, formData).pipe(map(user => user));
    }

    // Reports
    getReportTableTypeDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/reports/table-type-dropdown`).pipe(map(user => user));
    }

    getReportEntryTypeDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/reports/entry-type-dropdown`).pipe(map(user => user));
    }

    getReportSalesSummary(fromDate: string, toDate: string, dateField: string = 'booked', tableTypeId: string = '', entryModeId: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/reports/sales/summary?fromDate=${fromDate}&toDate=${toDate}&dateField=${dateField}&tableTypeId=${tableTypeId}&entryModeId=${entryModeId}`).pipe(map(user => user));
    }

    getReportSalesBookings(fromDate: string, toDate: string, dateField: string = 'booked', tableTypeId: string = '', entryModeId: string = '', page: number = 1) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/reports/sales/bookings?fromDate=${fromDate}&toDate=${toDate}&dateField=${dateField}&tableTypeId=${tableTypeId}&entryModeId=${entryModeId}&page=${page}`).pipe(map(user => user));
    }

    downloadReportSalesExcel(fromDate: string, toDate: string, dateField: string = 'booked', entryModeId: string = '', search: string = '') {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/club/reports/sales/download?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&dateField=" +
                dateField +
                "&entryModeId=" +
                entryModeId +
                "&search=" +
                search,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    getEntryStatsBookings(fromDate: string, toDate: string, dateField: string = 'booked', entryModeId: string = '', page: number = 1, search: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/reports/entry-stats/bookings?fromDate=${fromDate}&toDate=${toDate}&dateField=${dateField}&entryModeId=${entryModeId}&page=${page}&search=${search}`).pipe(map(user => user));
    }

    downloadEntryStatsExcel(fromDate: string, toDate: string, dateField: string = 'booked', entryModeId: string = '', search: string = '') {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/club/reports/entry-stats/download?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&dateField=" +
                dateField +
                "&entryModeId=" +
                entryModeId +
                "&search=" +
                search,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // Ratings
    getRatingsList(search: string = '', page: number = 1, rating: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/club/rating/list?search=${search}&page=${page}`).pipe(map(user => user));
    }

    // Vendor Settlement — same generic endpoint restaurant/laundry use, vendorType='club'
    getVendorSettlementList(page: number, limit: number, fromDate: string, toDate: string, vendorType: string, vendorId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&vendorType=${vendorType}&vendorId=${vendorId}`).pipe(map(user => user));
    }

    getVendorSettlementDetail(vendorType: string, vendorId: string, fromDate: string, toDate: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/detail/${vendorType}/${vendorId}?fromDate=${fromDate}&toDate=${toDate}`).pipe(map(user => user));
    }

}